import { SignalCellularNoSimSharp } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

type PropsType = {
  fullScreen?: boolean;
  onClick?: () => void;
};

const AccessDenied = (props: PropsType) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={`w-full ${props.fullScreen ? "h-screen" : "h-full"} flex items-center justify-center`}
      >
        <div className="w-full relative flex items-center justify-center">
          <div className="text-[642px] text-primary font-bold opacity-5">
            403
          </div>
          <div className="w-full absolute top-0 left-0 z-10 h-full flex flex-col gap-8 items-center justify-center">
            <SignalCellularNoSimSharp className="w-[128px] h-[129px] text-primary" />
            <div className="flex flex-col gap-2 justify-center">
              <div className="text-[32px] text-primary font-bold text-center">
                Access Denied
              </div>
              <div className="text-gray-400 text-center">
                This page is restricted.
                <br />
                You may not have the necessary permissions to proceed.
              </div>
            </div>
            <Button
              variant="contained"
              onClick={() => props.onClick ?? navigate("/")}
            >
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccessDenied;
